import {selector} from "recoil";
import {tokenSelector, tokenState} from "./auth";
import {
  AlarmServiceClient,
  AuthServiceClient,
  AuthServicePromiseClient,
  CallServiceClient,
  CustomerServiceClient,
  DeviceServiceClient,
  EventServiceClient,
  NotificationServiceClient,
  ReportServiceClient,
  ShiftServiceClient,
  UpdatesServiceClient,
  UserServiceClient,
  PrefServiceClient,
  MailServiceClient
} from "../grpc/api_grpc_web_pb";
import {StatusCode} from "grpc-web";
import {setRecoil} from "recoil-nexus";

let refreshingToken = false

const AuthStreamInterceptor = function (token) {
  this.token = token;
};

AuthStreamInterceptor.prototype.intercept = function (request, invoker) {
  const InterceptedStream = function (stream) {
    this.stream = stream;
  };
  InterceptedStream.prototype.on = function (eventType, callback) {
    const responseCallback = (response) => {
      if (response === undefined || !response.hasOwnProperty("code")) {
        callback(response);
        return this;
      }
      if (response.code === StatusCode.DEADLINE_EXCEEDED) {
        /*pushFailedRequestInRecoveryStack(invoker, request)
        refreshAuthToken()
          .then((resp) => {
            console.log("token refreshed: ", resp.toObject())
            updateTokenStateAndRecovery(resp.toObject())
            refreshingToken = false
          })
          .catch(err => {
            if (err !== "already-refreshing") {
              console.error("impossible to refresh auth token", err)
              refreshingToken = false
              forceLogout()
            }
          })
         */
        // todo
        forceLogout()
      } else if (response.code === StatusCode.UNAUTHENTICATED) {
        forceLogout()
      }
    };
    this.stream.on(eventType, responseCallback);
    return this;
  };
  const metadata = request.getMetadata();
  metadata['authorization'] = this.token;
  return new InterceptedStream(invoker(request));
};

let retryableRequests = []

const updateTokenStateAndRecovery = (token) => {
  // const tokenAtom = getRecoil(tokenState)
  setRecoil(tokenSelector, token)
  for (let req in retryableRequests) {
    console.log(req)
    req.invoker(req.request)
  }
  cleanRecoveryStack()
}

const pushFailedRequestInRecoveryStack = (invoker, request) => {
  retryableRequests.push({
    invoker: invoker,
    request: request,
  })
}

const cleanRecoveryStack = () => {
  retryableRequests = []
}

const tryParseTokenData = () => {
  try {
    return JSON.parse(localStorage.getItem("freddosrl_guardian__token"))
  } catch (err) {
    console.error(err)
    return {};
  }
}

const forceLogout = () => {
  cleanRecoveryStack()
  localStorage.removeItem("freddosrl_guardian__token")
  window.location.reload()
}

const refreshAuthToken = () => {
  if (refreshingToken) {
    return Promise.reject("already-refreshing")
  }
  refreshingToken = true
  console.debug("refreshing token")
  const authService = new AuthServicePromiseClient(process.env.REACT_APP_GRPC_SERVICE_URL, null, {})
  const tokenData = tryParseTokenData();
  if (!tokenData || !tokenData.refreshToken) {
    forceLogout()
    return Promise.reject("logged out")
  }
  const refreshRequest = new proto.api.RefreshRequest()
  refreshRequest.setToken(tokenData.refreshToken)
  return authService.refresh(refreshRequest, null)
}

const grpcAuthServiceSelector = selector({
  key: 'grpcAuthServiceSelector',
  get: () => {
    return new AuthServiceClient(process.env.REACT_APP_GRPC_SERVICE_URL, null, {
      maxPayload: 1024 * 1024 * 10000,
    })
  },
});

const grpcAlarmServiceSelector = selector({
  key: 'grpcAlertServiceSelector',
  get: ({get}) => {
    const token = get(tokenState);
    return new AlarmServiceClient(process.env.REACT_APP_GRPC_SERVICE_URL, null,
      {'streamInterceptors': [new AuthStreamInterceptor(token && token.accessToken)]}
    )
  }
});

const grpcCustomerServiceSelector = selector({
  key: 'grpcCustomerServiceSelector',
  get: ({get}) => {
    const token = get(tokenState);
    return new CustomerServiceClient(process.env.REACT_APP_GRPC_SERVICE_URL, null,
      {'streamInterceptors': [new AuthStreamInterceptor(token && token.accessToken)]}
    )
  },
});

const grpcUserServiceSelector = selector({
  key: 'grpcUserServiceSelector',
  get: ({get}) => {
    const token = get(tokenState);
    return new UserServiceClient(process.env.REACT_APP_GRPC_SERVICE_URL, null,
      {'streamInterceptors': [new AuthStreamInterceptor(token && token.accessToken)]}
    )
  },
});

const grpcEventServiceSelector = selector({
  key: 'grpcEventServiceSelector',
  get: ({get}) => {
    const token = get(tokenState);
    return new EventServiceClient(process.env.REACT_APP_GRPC_SERVICE_URL, null,
      {'streamInterceptors': [new AuthStreamInterceptor(token && token.accessToken)]}
    )
  },
});

const grpcUpdatesServiceSelector = selector({
  key: 'grpcUpdatesServiceSelector',
  get: ({get}) => {
    const token = get(tokenState);
    return new UpdatesServiceClient(process.env.REACT_APP_GRPC_SERVICE_URL, null,
      {'streamInterceptors': [new AuthStreamInterceptor(token && token.accessToken)]}
    )
  },
});

const grpcNotificationServiceSelector = selector({
  key: 'grpcNotificationServiceSelector',
  get: ({get}) => {
    const token = get(tokenState);
    return new NotificationServiceClient(process.env.REACT_APP_GRPC_SERVICE_URL, null,
      {'streamInterceptors': [new AuthStreamInterceptor(token && token.accessToken)]}
    )
  },
});

const grpcShiftServiceSelector = selector({
  key: 'grpcShiftServiceSelector',
  get: ({get}) => {
    const token = get(tokenState);
    return new ShiftServiceClient(process.env.REACT_APP_GRPC_SERVICE_URL, null,
      {'streamInterceptors': [new AuthStreamInterceptor(token && token.accessToken)]}
    )
  },
});

const grpcDeviceServiceSelector = selector({
  key: 'grpcDeviceServiceSelector',
  get: ({get}) => {
    const token = get(tokenState);
    return new DeviceServiceClient(process.env.REACT_APP_GRPC_SERVICE_URL, null,
      {'streamInterceptors': [new AuthStreamInterceptor(token && token.accessToken)]}
    )
  },
});

const grpcReportServiceSelector = selector({
  key: 'grpcReportServiceSelector',
  get: ({get}) => {
    const token = get(tokenState);
    return new ReportServiceClient(process.env.REACT_APP_GRPC_SERVICE_URL, null,
      {'streamInterceptors': [new AuthStreamInterceptor(token && token.accessToken)]}
    )
  },
});

const grpcCallServiceSelector = selector({
  key: 'grpcCallServiceSelector',
  get: ({get}) => {
    const token = get(tokenState);
    return new CallServiceClient(process.env.REACT_APP_GRPC_SERVICE_URL, null,
      {'streamInterceptors': [new AuthStreamInterceptor(token && token.accessToken)]}
    )
  },
});

const grpcPrefServiceSelector = selector({
  key: 'grpcPrefServiceSelector',
  get: ({get}) => {
    const token = get(tokenState);
    return new PrefServiceClient(process.env.REACT_APP_GRPC_SERVICE_URL, null,
      {'streamInterceptors': [new AuthStreamInterceptor(token && token.accessToken)]}
    )
  },
});

const grpcMailServiceSelector = selector({
  key: 'grpcMailServiceSelector',
  get: ({get}) => {
    const token = get(tokenState);
    return new MailServiceClient(process.env.REACT_APP_GRPC_SERVICE_URL, null,
      {'streamInterceptors': [new AuthStreamInterceptor(token && token.accessToken)]}
    )
  },
});

export {
  grpcAuthServiceSelector,
  grpcAlarmServiceSelector,
  grpcCustomerServiceSelector,
  grpcUserServiceSelector,
  grpcEventServiceSelector,
  grpcUpdatesServiceSelector,
  grpcNotificationServiceSelector,
  grpcShiftServiceSelector,
  grpcDeviceServiceSelector,
  grpcReportServiceSelector,
  grpcCallServiceSelector,
  grpcPrefServiceSelector,
  grpcMailServiceSelector
}